<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <span name="title">출장자</span>
      </v-expansion-panel-header>

      <v-expansion-panel-content class="signLine-content">
        <v-list class="add-box-viewer-list" flat>
          <v-list-item-group
            v-for="(joiner, index) in GET_APP_MAP_DATA.bizTripJoiner"
            :key="index"
          >
            <v-list-item class="px-0" v-if="joiner.name" :ripple="false">
              <v-list-item-content>
                <v-list-item-title
                  ><span class="name" v-text="joiner.name"></span
                  ><span class="sub-desc ml-2" v-text="joiner.jikweeNm"></span
                  ><span class="sub-desc divider" v-text="joiner.orgNm"></span
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- 추가내용 -->
            <v-list-item
              v-if="
                GET_APP_MAP_DATA.sabunNoteCol &&
                joiner.note != '' &&
                joiner.note != null
              "
              class="opinion-outer"
            >
              <v-list-item-content class="pt-0 pb-5 pr-5">
                <v-sheet class="opinion-wrap" color="lightGrey">
                  <div class="opinion-desc">{{ joiner.note }}</div>
                </v-sheet>
              </v-list-item-content>
            </v-list-item>

            <v-divider
              v-show="GET_APP_MAP_DATA.bizTripJoiner.length - 1 > index"
            ></v-divider>
          </v-list-item-group>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
/* 출장동행인 리스트 */
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_APP_MAP_DATA']),
  },
};
</script>

<style></style>
